// extracted by mini-css-extract-plugin
module.exports = {"root":"Marquee_root__jkJK1","primary":"Marquee_primary__KlpZp","secondary":"Marquee_secondary__8dcL6"};